import React from 'react'
import type { Voice } from '@/features/voice/domain/models/voice.ts'
import { useTranslation } from 'react-i18next'
import Button from '../../common/Button.tsx'
import PlayButton from '@/components/common/PlayButton.tsx'

interface VoiceBoxProps {
  voice: Voice
  onSelected?: () => void
  isSelectable?: boolean
}

const VoiceBox: React.FC<VoiceBoxProps> = ({
  voice: {
    id,
    name,
    flag,
    language,
    accent,
    picture,
    audioSampleUrl,
    tags,
    hasTTS,
  },
  onSelected,
  isSelectable = true,
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex w-full select-text flex-col gap-4 rounded-sm bg-zinc-700 p-4 shadow-[0px_0px_8px_-2px_rgba(0,0,0,0.20)]">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <img className="h-11 w-11 rounded" src={picture} alt="avatar" />
          <div className="flex flex-grow flex-col justify-center">
            <div className="font-bold capitalize text-white">{name}</div>
            <div className="text-xs font-semibold capitalize text-white">
              {flag} {language} | {accent}
            </div>
          </div>
          <PlayButton soundId={id} url={audioSampleUrl} playAt={1} />
        </div>
        <div className="flex flex-wrap gap-1">
          {tags.map((tag, tagIndex) => (
            <div
              key={tagIndex}
              className="rounded-sm bg-zinc-500 px-1.5 py-0.5 text-xs font-semibold capitalize text-white"
            >
              {tag}
            </div>
          ))}
        </div>
      </div>
      {isSelectable && (
        <div className="flex">
          {hasTTS && onSelected && (
            <Button fullWidth onClick={onSelected}>
              {t('ls_voice_box_select')}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default VoiceBox
